import queryString from "query-string";

import { PureAemComponent } from "@components/pureAemComponent";

export interface RouterComponentInterface {
    activateComponent(): void;
    deactivateComponent(): void;
}

export class RouterComponent
    extends PureAemComponent
    implements RouterComponentInterface
{
    id: string;
    byHash: boolean;
    enableHistoryTracking: boolean;

    constructor(element: HTMLElement) {
        super(element);
        this.id = this.element.id;
        this.byHash = true;
        this.enableHistoryTracking =
            this.element.dataset.enableHistoryTracking === "true";
        this.getInitState();
        this.bindRouterEventHandlers();
    }

    /**
     * Get the hash value and check if it matches this component
     */
    getInitState(): void {
        if (this.checkIfHashValueMatches(window.location.hash)) {
            this.activateComponent();
        } else {
            this.checkQueryParamForId();
        }
    }

    /**
    Check if the search params contain the ID with value "true"
     */
    checkQueryParamForId(): void {
        const queryParams = queryString.parse(location.search);
        if (queryParams[this.id] && queryParams[this.id] === "true") {
            this.byHash = false;
            this.activateComponent();
        } else {
            this.deactivateComponent();
        }
    }

    /**
     * Bind the specific router event handlers
     */
    bindRouterEventHandlers(): void {
        window.addEventListener("hashchange", this.handleHashChange.bind(this));
    }

    /**
     * Activate / deactivate the component based on the hash value
     * @param e
     */
    handleHashChange(e: { oldURL: string; newURL: string }): void {
        const oldHash: string = new URL(e.oldURL).hash;
        const newHash: string = new URL(e.newURL).hash;

        if (this.checkIfHashValueMatches(newHash)) {
            this.activateComponent();
        } else if (this.checkIfHashValueMatches(oldHash)) {
            this.deactivateComponent();
        }
    }

    /**
     * Check if the given hash value matches this element's id
     * @param hashVal
     * @returns {boolean}
     */
    checkIfHashValueMatches(hashVal: string): boolean {
        return hashVal.substring(1, hashVal.length) === this.id;
    }

    /**
     * Removes the hash from our location
     */
    removeHash(): void {
        if (!this.enableHistoryTracking) {
            // @ts-ignore
            window.history.back(1);
            window.history.replaceState(
                null,
                "",
                location.pathname + location.search,
            );
            return;
        }
        window.location.hash = "";
        this.push("");
    }

    /**
     * Unsets the queryparam
     */
    unsetQueryParam(): void {
        const url = new URL(location.href);
        url.searchParams.delete(this.id);
        window.history.replaceState(null, "", url.pathname + url.search);
    }

    /**
     * Add entry to our history
     * @param route {string} - Route
     */
    push(route: string): void {
        window.history.pushState(null, "", route);
    }

    activateComponent(): void {
        throw Error("Not implemented");
    }

    deactivateComponent(): void {
        throw Error("Not implemented");
    }
}
